import Playground from 'components/Playground';
import Collapse from "components/Collapse";
import * as React from 'react';
export default {
  Playground,
  Collapse,
  React
};